// AIMS PWA - reload safety guard (AIMS-Offline-Inspection.md §7/§10).
//
// A new service-worker version must NEVER silently reload the page mid-form or
// while offline work is unsynced. This tiny module tracks whether an inspection
// form is open; the update prompt combines that with a pending-uploads check to
// decide when a reload is safe. Module-level (not React state) so any component
// can register without prop-drilling.

let _openForms = 0;

// InspectionForm calls this on open (true) / close (false).
export function setFormOpen(open) {
  if (open) _openForms += 1;
  else _openForms = Math.max(0, _openForms - 1);
}

export function isFormOpen() {
  return _openForms > 0;
}
